module.exports = __webpack_public_path__ + "img/dogecoin-logo.b342c58c.svg";